import React from "react";
import styles from "./TextComponent.module.css";
import { ReactComponent as BackIcon } from "../../assets/images/textBackIcon.svg";
// import { useNavigate } from "react-router-dom";

const TextComponent = (props) => {
    // const navigate = useNavigate();

  return (
    <div className={styles.mainDiv} style={props?.divStyle}>
      {/* {props?.backIcon &&
        <div onClick={() => navigate(-1)} className={styles.backIconDiv}>
          <BackIcon width={20} height={20} />
        </div>
      } */}

      <span
        id={props?.id}
        {...props}
        ref={props?.ref}
        className={`${props?.className} ${styles.Container}`}
        onClick={props.onClick}
        style={props?.style}
        
        // style={{
        //   textAlign: props?.textAlign ? props?.textAlign : "left",
        //   padding: props?.padding ? props?.padding : "10px",
        //   color: props?.color ? props?.color : "var(--black-color)",
        //   fontSize: props?.fontSize
        //     ? props?.fontSize
        //     : " var(--subparagraph-font-size)",
        //   textDecoration: props?.textDecoration
        //     ? props?.textDecoration
        //     : "default",
        //   margin: props?.margin ? props?.margin : "0px",
        //   cursor: props?.cursor ? props?.cursor : "default",
        // }}
      >
        {props.text}
        {props.children}
      </span>
    </div>
  );
};

export default TextComponent;
